<template>
    <modal 
        name="loading-modal"
        @before-open="beforeOpen"
        :clickToClose=false
        :width="400"
        :height="300"
        class="loading-container"
    >
    <div class="loading-title">{{title}}</div>
    <div class="loading-subtitle">{{subtitle}}</div>
    <div class="orbit-spinner">
        <div class="orbit"></div>
        <div class="orbit"></div>
        <div class="orbit"></div>
    </div>
    </modal>
</template>


<script>

export default {
    name: 'ModalLoading',
    data() {
        return {
            title: 'Generating report',
            subtitle: 'Loading...'
        }
    },
    methods: {
        beforeOpen(event) {
            this.title = event.params.title
            this.subtitle = event.params.subtitle
        },
    }
}
</script>


<style lang="stylus" scoped>
.loading-container
  background: linear-gradient(90deg, $charade 0, $comet 100%)
  display: flex
  text-align: center
  margin: auto

  >>> .vm--modal
    background: rgb(239, 239, 242)
    background: linear-gradient(180deg, rgba(239, 239, 242, 1) 0, rgba(206, 208, 217, 1) 100%)
    display: flex
    flex-direction: column
    justify-content: center

    .loading-title {
        m-font-size(24, 26)
        font-weight: bold
        color: $shark
        margin-bottom: 20px
    }
    .loading-subtitle {
        m-font-size(16, 18)
        color: $shark
        margin-bottom: 40px
    }

    .orbit-spinner, .orbit-spinner * {
      box-sizing: border-box;
      margin: 0 auto
    }

    .orbit-spinner {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      perspective: 800px;
    }

    .orbit-spinner .orbit {
      position: absolute;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    .orbit-spinner .orbit:nth-child(1) {
      left: 0%;
      top: 0%;
      animation: orbit-spinner-orbit-one-animation 1200ms linear infinite;
      border-bottom: 4px solid #ff1d5e;
    }

    .orbit-spinner .orbit:nth-child(2) {
      right: 0%;
      top: 0%;
      animation: orbit-spinner-orbit-two-animation 1200ms linear infinite;
      border-right: 4px solid #ff1d5e;
    }

    .orbit-spinner .orbit:nth-child(3) {
      right: 0%;
      bottom: 0%;
      animation: orbit-spinner-orbit-three-animation 1200ms linear infinite;
      border-top: 4px solid #ff1d5e;
    }

    @keyframes orbit-spinner-orbit-one-animation {
      0% {
        transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
      }
      100% {
        transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
      }
    }

    @keyframes orbit-spinner-orbit-two-animation {
      0% {
        transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
      }
      100% {
        transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
      }
    }

    @keyframes orbit-spinner-orbit-three-animation {
      0% {
        transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
      }
      100% {
        transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
      }
    }

</style>